var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8307 14.875C17.0896 14.875 16.3021 14.3036 16.3021 13.2475V12.4836C16.296 12.4373 16.261 12.39 16.2032 12.3436C15.3282 11.6611 14.8444 10.64 14.8671 9.5375C14.8907 8.69137 15.2171 7.91 15.7535 7.30887C15.386 7.16887 15.001 7.08137 14.5985 7.035C14.4261 7.014 14.0682 7 13.9632 7C12.5519 7 11.2271 7.54862 10.2244 8.55137C9.79299 8.98275 9.44299 9.5025 9.19799 10.0852C8.87686 10.7791 8.71411 11.5202 8.71411 12.2789C8.71411 12.3664 8.72024 12.4539 8.72549 12.5414V12.565C8.69049 12.7986 8.60911 13.0139 8.49799 13.195L7.20911 15.0614C7.04549 15.3125 6.96411 15.4525 6.96411 15.61C6.96411 16.0064 7.29049 16.3336 7.68774 16.3336H8.74911V17.955C8.74911 18.6725 9.33274 19.25 10.0441 19.25C10.1841 19.25 10.318 19.2264 10.4116 19.1975L11.6602 18.8536V20.5625C11.6602 20.8014 11.8589 21 12.0977 21H17.0564C17.2952 21 17.4939 20.8014 17.4939 20.5625V17.6925C17.4939 16.9986 17.6864 16.2925 18.0477 15.6564C18.2516 15.4114 18.4327 15.1489 18.5902 14.875H17.8307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5579 12.9325V13.3525C19.5579 13.7086 19.2666 14 18.9043 14H17.8307C17.5157 14 17.1771 13.7664 17.1771 13.2475V12.9325H19.5579Z",
    fill: "#C2D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.993 9.60754C20.993 10.395 20.643 11.13 20.0305 11.6262C19.7855 11.8248 19.628 12.0812 19.5755 12.3498H17.1666C17.1255 12.0873 16.9802 11.8423 16.7405 11.6559C16.093 11.1484 15.7255 10.3845 15.743 9.55591C15.7718 8.16729 16.933 7.01841 18.3268 7.00091C19.033 6.98341 19.7093 7.25729 20.2168 7.75954C20.7182 8.24779 20.993 8.90754 20.993 9.60754Z",
    fill: "#C2D8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_1142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Earner.c3e6e808b02f64b81b38de9724bab3c0.svg";